import { render, staticRenderFns } from "./CountryRule.vue?vue&type=template&id=2fae4d05&"
import script from "./CountryRule.vue?vue&type=script&lang=js&"
export * from "./CountryRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports